<template>
<div>
  <v-card class="progress-container" v-if="initialLoading">
    <v-progress-circular :size="120" color="primary" indeterminate></v-progress-circular>
  </v-card>
  <div v-else>
    <v-layout>
      <v-container>
        <v-layout>
          <v-flex xs1>
            <v-dialog width="500" v-model="createDialog">
              <v-btn block color="primary" slot="activator">
                {{$t('archive.upload') }}
              </v-btn>
              <v-card>
                <v-card-title class="headline" primary-title>
                  {{$t('archive.add-file') }}
                </v-card-title>
                <create-form @exit="formUploaded"></create-form>

              </v-card>
            </v-dialog>
          </v-flex>

          <v-flex xs1>
            <FilterView v-on:filter="setUpFilter" />
          </v-flex>
          <v-flex offset-xs2 xs2>
            <h2 class="edit-Text" v-if="editMode">{{$t('archive.edit_mode') }}</h2>
          </v-flex>

          <v-flex offset-xs3 xs1>
            <v-switch v-model="editMode" :label="`${$t('archive.edit_mode')}`"></v-switch>
          </v-flex>
          <v-flex offset-xs1 zs1>
            <FilterNew v-on:filter="setUpFilter" />
          </v-flex>
        </v-layout>

        <!-- Filtracja data -->
        <v-layout>
          <v-flex xs2>
            <v-menu ref="menuFrom" v-model="menuFrom" :close-on-content-click="false" :nudge-right="40" :return-value.sync="dateFrom">
              <template slot="activator">
                <v-text-field v-model="dateFrom" :label="`${$t('cycle.from')}`" prepend-icon="event" readonly></v-text-field>
              </template>
              <v-date-picker v-model="dateFrom" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menuFrom = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.menuFrom.save(dateFrom)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2>
            <v-menu ref="menuTo" v-model="menuTo" :close-on-content-click="false" :nudge-right="40" :return-value.sync="dateTo">
              <template slot="activator">
                <v-text-field v-model="dateTo" :label="`${$t('cycle.to')}`" prepend-icon="event" readonly></v-text-field>
              </template>
              <v-date-picker v-model="dateTo" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menuTo = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.menuTo.save(dateTo)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs2 sm2>
            <v-select style="margin-left:2rem;" :items="sortType" item-text="name" item-value="value" v-model="sort" :label="`${$t('archive.filter.sort')}`"></v-select>
          </v-flex>

          <v-flex xs2 sm2>
            <v-select style="margin-left:2rem;" :items="searchPlace" item-text="name" item-value="value" v-model="place" :label="`${$t('archive.filter.search_in')}`"></v-select>
          </v-flex>

          <v-btn @click="resetDate" fab small>
            <v-icon small>close</v-icon>
          </v-btn>
          <v-btn @click="load" small fab>
            <v-icon small>refresh</v-icon>
          </v-btn>
        </v-layout>

        <!-- Filtracja INFO -->
        <v-layout class="right-animation" v-if="filter.id!=0">
          <v-flex xs12>
            <v-card class="d-flex pa-2">
              <h3> {{ $t('archive.filter.choosen_filter') }} </h3>
            </v-card>
            <v-card class="pa-2">
              <v-badge right bordered overlap color="red">
                <template v-slot:badge>
                  <span>X</span>
                </template>
                <v-btn @click="clearFilter" class="white--text" color="green" depressed>
                  {{filter.name}}
                </v-btn>
              </v-badge>
            </v-card>
          </v-flex>
        </v-layout>


        <!-- Filtracja text -->
        <v-layout style="margin-bottom:2rem" class="left-animation" v-if="filter.id==0">
          <v-flex lg9>
            <v-text-field v-model="search" :label="`${$t('archive.search')}`"></v-text-field>
          </v-flex>
          <v-flex lg2 offset-xs1>
            <v-select :items="sizes" v-model="size" :label="$t('archive.size') " class="input-group--focused" item-value="text"></v-select>
          </v-flex>
        </v-layout>


        <v-container row wrap v-for="(archive,index) in archivesData" :key="archive.id" grid-list-md text-xs-center>
          <div class="margin">
            <v-layout style="margin-bottom: 0.7rem">
              <v-flex lg7>
                <v-layout>
                  <v-flex xs11>
                    <v-text-field v-model="archive.customName" :label="`${$t('archive.file-name')}`" :readonly="!editMode"></v-text-field>
                  </v-flex>
                  <v-flex xs1 style="position:relative" v-if="isEdited(archive,'customName')">
                    <v-chip v-if="chipVisible && editMode" style="position:absolute;top:-20px;transform: translateX(-50%);:" small>Kliknij, na haczyk żeby zapisac</v-chip>
                    <v-icon v-if="editMode" @click="update(archive,'customName')" style="position:absolute;cursor:pointer;" class="light-green--text">check</v-icon>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs2>
                <v-layout>
                  <v-flex xs11>
                    <v-text-field v-model="archive.archType" :label="`${$t('archive.arch_type')}`" :readonly="!editMode"></v-text-field>
                  </v-flex>
                  <v-flex xs1 style="position:relative" v-if="isEdited(archive,'archType')">
                    <v-chip v-if="chipVisible && editMode" style="position:absolute;top:-20px;transform: translateX(-50%);:" small>Kliknij, na haczyk żeby zapisac</v-chip>
                    <v-icon v-if="editMode" @click="update(archive,'archType')" style="position:absolute;cursor:pointer;" class="light-green--text">check</v-icon>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex lg1 offset-xs1>
                <EditArchive :archive="archive" :archiveOrgin="originArchivesData[index]" />
              </v-flex>
              <v-flex lg1>
                <v-btn @click="deleteFile(archive.id,index)">
                  Usun
                </v-btn>
              </v-flex>
            </v-layout>

            <v-layout style="margin-bottom: 1.5rem">
              <v-flex lg2>
                <v-layout>
                  <v-flex xs11>
                    <v-text-field v-model="archive.creationTime" :label="`${$t('archive.creation_date')}`" :readonly="!editMode"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs2>
                <v-layout>
                  <v-flex xs11>
                    <v-text-field v-model="archive.modifyTime" :label="`${$t('archive.modify_date')}`" :readonly="!editMode"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout row align-content-center>
              <v-flex lg3 xs4>
                <v-card>
                  <v-img height="170px" @click="open(archive.id)" class="cursorPointner" :src="'data:image/png;base64,'+ archive.thumbImg"></v-img>
                </v-card>
              </v-flex>
              <v-flex lg7 xs6 offset-xs1>
                <v-layout>
                  <v-flex xs11>
                    <v-textarea :label="`${$t('archive.text')}`" v-model="archive.text" :readonly="!editMode"></v-textarea>
                  </v-flex>
                  <v-flex style="position:relative" v-if="isEdited(archive,'text')" xs1>
                    <v-chip v-if="chipVisible && editMode" style="position:absolute;top:-20px;transform: translateX(-50%);:" small>Kliknij na haczyk żeby zapisac</v-chip>
                    <v-icon v-if="editMode" @click="update(archive,'text')" style="position:absolute;cursor:pointer;" class="light-green--text">check</v-icon>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex lg2 xs2 offset-xs1>
                <v-layout>
                  <v-flex xs11>
                    <v-textarea :label="`${$t('archive.note')}`" v-model="archive.note" :readonly="!editMode"></v-textarea>
                  </v-flex>
                  <v-flex style="position:relative" v-if="isEdited(archive,'note')" xs1>
                    <v-chip v-if="chipVisible && editMode" style="position:absolute;top:-20px;transform: translateX(-50%);:" small>Kliknij na haczyk żeby zapisac</v-chip>
                    <v-icon v-if="editMode" @click="update(archive,'note')" style="cursor:pointer;" class="light-green--text">check</v-icon>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-spacer></v-spacer>
            </v-layout>
          </div>
          <hr>
        </v-container>
        <v-container>
          <v-flex xs4 offset-xs4>
            <v-btn :disabled="!loadMoreAvailable" @click="loadNext" color="#3bb300" class="loadNext">
              {{ $t('archive.load-more') }}
            </v-btn>
          </v-flex>
        </v-container>
      </v-container>
    </v-layout>
  </div>
</div>
</template>

<script>
import http from '@/plugins/http'
import CreateForm from "./dialogs/CreateArchive"
import EditArchive from "./dialogs/EditArchive"
import FilterView from "./FilterView"
import FilterNew from "./FilterNew"
import DataTimeHelper from '@/plugins/DataTimeHelper'

export default {
  components: {
    CreateForm,
    FilterView,
    EditArchive,
    FilterNew
  },
  computed: {
    archives() {
      return this.archivesData
    }
  },
  data() {
    return {
      dateFrom: "",
      menuFrom: false,
      dateTo: "",
      menuTo: false,
      sort: "DESC",
      place: 2,
      editMode: false,
      chipVisible: false,
      block: false,
      i: 0,
      createDialog: false,
      archivesData: [],
      originArchivesData: [],
      search: "",
      previousSearchText: "",
      awaitingSearch: false,
      loadMoreAvailable: true,
      size: 5,
      sizes: [5, 10, 20],
      initialLoading: false,
      filter: {
        id: 0,
        name: ""
      },
      searchPlace: [{
        name: this.$t('archive.filter.doc_and_note'),
        value: 2
      }, {
        name: this.$t('archive.filter.doc'),
        value: 1
      }, {
        name: this.$t('archive.filter.note'),
        value: 0
      }],
      sortType: [{
          name: this.$t('archive.filter.from_newest'),
          value: "DESC"
        },
        {
          name: this.$t('archive.filter.from_oldest'),
          value: "ASC"
        }
      ],
    }
  },
  methods: {
    load() {
      let filter = this.getTimeCondition();

      if (this.filter.id > 0)
        filter = filter.concat("filter=" + this.filter.id)

      http.get('archives/find?' + filter).then(data => {
        if (data.data.length < this.size)
          this.loadMoreAvailable = false
        this.archivesData = data.data.sort((a, b) => {
          if (this.sort == "DESC") return b.id - a.id
          return a.id - b.id
        });

        this.originArchivesData = this.archivesData.map(a => Object.assign({}, a));
      }).finally(() => this.initialLoading = false)
    },
    loadNext() {
      this.page++;
      let search = ""
      if (this.search != "")
        search = "/" + this.search

      let filter = "&" + this.getTimeCondition()
      if (this.filter.id > 0)
        filter = "filter=" + this.filter.id


      http.get('archives/find' + search + "?offset=" + this.archivesData.length + "&size=" + this.size + filter).then(data => {
        let newArchives = data.data.filter(el => undefined == this.archivesData.find(archive => archive.id == el.id));
        this.addNewArchives(newArchives)
      })
    },
    getTimeCondition() {
      let filter = ""
      if (this.dateFrom != undefined && this.dateFrom != "")
        filter = filter.concat("from=" + this.dateFrom + "&")
      if (this.dateTo != undefined && this.dateTo != "")
        filter = filter.concat("to=" + this.dateTo + "&")
      if (this.sort != undefined && this.sort != "")
        filter = filter.concat("sort=" + this.sort + "&")
      if (this.place !== undefined && this.place !== "")
        filter = filter.concat("place=" + this.place + "&")


      return filter
    },
    addNewArchives(newArchives) {
      if (newArchives.length < this.size) {
        this.loadMoreAvailable = false
        this.$store.commit("setSnack", {
          message: this.$t('archive.loaded', {
            count: newArchives.length
          }),
          color: "warning"
        })
      }
      let sorted = newArchives.sort((a, b) => {
        if (this.sort == "DESC") return b.id - a.id
        return a.id - b.id
      });

      this.archivesData = this.archivesData.concat(sorted)
      this.originArchivesData = this.originArchivesData.concat(sorted.map(a => Object.assign({}, a)));
    },
    formUploaded(data) {
      this.createDialog = false
      if (data.data.Status == "SS_OK" && data.data.MainPid != undefined) {
        this.$store.commit("setSnack", {
          message: this.$t('archive.process'),
          color: "warning"
        })
        this.requestArchiveStatus(data.data.MainPid)
      } else {
        this.showAdedError()
      }
    },
    requestArchiveStatus(id) {
      let bindComp = this
      let interval = setInterval(function() {
        http.get('archives/status/' + id).then(data => {
          if (data.data.Status == "SS_OK" && data.data.ArchiveFile != undefined) {
            if (data.data.ArchiveFile.RTEngineStatus == "RTPES_DONE") {
              clearInterval(interval);
              bindComp.getArchive(id)
              bindComp.showAdedSucces()
            }
            if (data.data.ArchiveFile.RTEngineStatus == "RTPES_ERROR") {
              bindComp.showAdedError()
              clearInterval(interval);
            }
          }
        }).catch(() => {
          clearInterval(interval);
          this.showAdedError()
        })
      }, 1500);
    },
    isEdited(archive, field) {
      let archiveOrgin = this.originArchivesData.find(el => archive.id == el.id)
      if (archiveOrgin == undefined)
        return false


      if (archive[field] != archiveOrgin[field]) {
        if (!this.block) {
          this.chipVisible = true
          this.block = true;

          setTimeout(() => {
            this.chipVisible = false
          }, 3000)

        }
        return true;
      }

      return false
    },
    update(archive, field) {
      let dataUpdate = {}
      dataUpdate[field] = archive[field]
      http.put('archive/' + archive.id, dataUpdate).then((data) => {
        if (data.data.status == "SS_OK") {
          let orgArch = this.originArchivesData.find(el => el.id == archive.id)
          orgArch[field] = archive[field]
          archive.modifyTime = DataTimeHelper.getDateTime()
          orgArch.modifyTime = DataTimeHelper.getDateTime()
        }
      })
    },
    setUpFilter(data) {
      this.filter = data
      this.load()
    },
    clearFilter() {
      this.filter = {
        name: '',
        id: 0
      }
      this.loadMoreAvailable = true
      this.load()
    },
    resetDate() {
      this.dateTo = ""
      this.dateFrom = ""
    },
    getArchive(id) {
      http.get('archives/get/' + id).then(data => {
        this.archivesData = data.data.concat(this.archivesData)
      }).catch(() => {
        this.showAdedError()
      })
    },
    showAdedError() {
      this.$store.commit("setSnack", {
        message: this.$t('archive.upload_error'),
        color: "danger"
      })
    },
    showAdedSucces() {
      this.$store.commit("setSnack", {
        message: this.$t('archive.added'),
        color: "success"
      })
    },
    open(id) {
      this.$store.commit("setSnack", {
        message: this.$t('archive.image_downloading'),
        color: "success",
        timeout: 1000
      })

      http.get('archives/show/' + id).then(data => {
        if (data.data.type == "image/tiff") {
          window.open('data:' + data.data.type + ";base64," + encodeURI(data.data.data), '_blank');
        } else {
          let win = window.open("")
          win.document.write('<iframe width=\'100%\' height=\'100%\' src=\'data:' + data.data.type + ";base64," + encodeURI(data.data.data) + "'></iframe>");
        }
      }).catch(() => {
        this.$store.commit("setSnack", {
          message: this.$t('archive.image_error'),
          color: "success",
        })
      })
    },
    deleteFile(id, index) {
      let deleted = false;
      http.post('archives/delete/' + id).then((data) => {
        if (data.data.result == "SS_OK") {
          this.archivesData.splice(index, 1);
          deleted = true
        }
      }).finally(() => {
        if (!deleted) {
          this.$store.commit("setSnack", {
            message: this.$t('archive.delete_error'),
            color: "success"
          })
        }
      })
    }
  },
  created() {
    this.initialLoading = true;
    this.load();
    this.$store.dispatch('loadArchiveFilters')
  },
  watch: {
    search: function() {
      if (!this.awaitingSearch) {
        setTimeout(() => {
          let search = ""
          if (this.search != "")
            search = "/" + this.search
          this.previousSearchText = this.search

          let filter = "".concat("&" + this.getTimeCondition())

          http.get('archives/find' + search + "?size=" + this.size + filter).then(data => {
            this.archivesData = []
            this.loadMoreAvailable = true
            this.addNewArchives(data.data)
          }).catch(() => this.loadMoreAvailable = true)

          this.awaitingSearch = false;
        }, 1200); // 1.2 sec delay
      }
      this.awaitingSearch = true;
    },
    sort: function() {
      this.load()
    },
    place: function() {
      this.load()
    }
  }
}
</script>

<style scoped>
.margin {
  margin-bottom: 5rem;
  margin-top: 2.5rem;
}

.btn-edit {
  background-color: green !important
}

.inEditing {
  background-color: #e8eaf6;
  border-radius: 10px 10px;
}

.cursorPointner {
  cursor: pointer;
  object-fit: contain;
}

.edit-Text {
  position: fixed;
  top: 0.7rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
  text-shadow: 1px 1px silver;
}

.loadNext {
  width: 100%;
  background-color: #af4a63;
  color: white;
  padding: 1.5rem 1.5rem;
  border-radius: 1rem;
}

.progress-container {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
}

.right-animation {
  animation-duration: 0.5s;
  animation-name: rightAnimation;
}

.left-animation {
  animation-duration: 0.5s;
  animation-name: leftAnimation;
}

@media only screen and (max-width: 600px) {
  .edit-Text {
    display: none;
  }
}

@keyframes rightAnimation {
  0% {
    -webkit-transform: translateX(-50%);
    opacity: 0.1;
  }

  80% {
    -webkit-transform: translateX(10%);
    opacity: 0.6;
  }

  100% {
    -webkit-transform: translateX(0%);
    opacity: 1;
  }
}

@keyframes leftAnimation {
  0% {
    -webkit-transform: translateX(50%);
    opacity: 0.1;
  }

  80% {
    -webkit-transform: translateX(-10%);
    opacity: 0.6;
  }

  100% {
    -webkit-transform: translateX(0%);
    opacity: 1;
  }
}
</style>
